module.exports = __webpack_public_path__ + "static/media/FAQpattern.3a3c0cb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FAQ/FAQpattern.png
// module id = 114
// module chunks = 0